import { render, staticRenderFns } from "./SelectSeatPage.vue?vue&type=template&id=67460fa6&scoped=true&"
import script from "./SelectSeatPage.vue?vue&type=script&lang=ts&"
export * from "./SelectSeatPage.vue?vue&type=script&lang=ts&"
import style0 from "./SelectSeatPage.vue?vue&type=style&index=0&id=67460fa6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67460fa6",
  null
  
)

export default component.exports